import React from 'react';
import { Box, CircularProgress } from '../utils/mui-imports';
import BrowsLooks from './BrowseLooksNewUI';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const LazyBrowseLooks = ({ showAll = true }) => {
  const [containerRef, isIntersecting, hasIntersected] = useIntersectionObserver({
    threshold: 0.2,
    rootMargin: '100px 0px',
    triggerOnce: true
  });

  return (
    <div ref={containerRef}>
      {hasIntersected ? (
        <BrowsLooks showAll={showAll} />
      ) : (
        <Box
          sx={{
            height: '75dvh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white'
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </div>
  );
};

export default LazyBrowseLooks;
